export const primaryMapStyles =  [{
    "featureType": "poi",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
},
{
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
},
{
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
        { color: '#333333' },
        { weight: .15 }
    ]
},
{
    "featureType": "administrative.locality",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
},
{
    "featureType": "administrative.province",
    "elementType": "labels",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
},
{
    "featureType": "landscape",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
},
{
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [
        { color: '#333333' },
        { weight: 2 }
    ]
},
{
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
        { color: '#333333' },
        { weight: 2 }
    ]
},
{
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
    //   { color: '#4682b4' }
      { color: '#A7B1BB' }
    ]
  }
]